module.exports = __webpack_public_path__ + "assets/img/tx21_1.0ed83d01.jpg";